import { Link } from 'react-router-dom';
import { invitationState2 } from '../../../api/stores';
import clsx from 'clsx';
import { buttonVariants } from '@playcastdotio/Shadcn';

export const DisconnectedPlayer = () => {
  return (
    <div className='flex flex-col items-center justify-center gap-y-8'>
      <div className='grid-rows col-span-full mx-auto grid content-center justify-center gap-y-4 text-center lg:gap-y-8'>
        {/* <p className='row-auto text-lg italic my-0 mx-auto'>You've been invited to a playcast!</p> */}
        <h2 className='row-auto mt-4 text-2xl font-bold lg:text-3xl'>{invitationState2.currentState.selectedInvite?.description}</h2>
        You disconnected. Thanks for playing!
      </div>
      <div>
        <Link to='https://playcast.io' className={clsx(buttonVariants(), 'max-w-48 text-wrap py-8 text-center')}>
          Host Your Own Session on Playcast.io
        </Link>
      </div>
    </div>
  );
};
